import React, { useState, useEffect } from "react";
import Title from "@/components/Title/Title";
import { usePressData } from "./usePressData";
import S from "./PressReleases.styled";
import GreenArrow from "@/src/images/GreenArrow.png";
import WhiteArrow from "@/src/images/WhiteArrow.png";
import ArrowButton from "@/components/Buttons/ArrowButton/ArrowButton";
import { useLocalization } from "@/contexts/Localization";

export interface Props {
  title: string;
  displayOptions: string;
}

const PressReleases: React.FC<Props> = ({ title, displayOptions }) => {

  const { language } = useLocalization();
  const useData = usePressData(language);

  const [data, setData] = useState(useData);

  useEffect(() => {
    if (displayOptions === "four") {
      setData(useData.slice(0, 4));
    } else if (displayOptions === "all") {
      setData(useData);
    }
  }, [displayOptions]);

  const button = {
    url: "/om-oss/pressmeddelanden",
    target: "_self",
    title: "Se alla pressmeddelanden",
  };

  const renderItems = data.map((item: { uri: string | undefined; date: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }, index: React.Key | null | undefined) => {
    return (
      <S.Link key={index} href={item.uri}>
        <S.ItemWrapper>
          <S.LeftWrapper>
            <S.ItemText>Pressrelease</S.ItemText>
            <S.ItemDate>{item.date}</S.ItemDate>
          </S.LeftWrapper>
          <S.RightWrapper>
            <S.ItemTitle>{item.title}</S.ItemTitle>
            <S.Arrow src={GreenArrow} alt="arrow" />
            <S.Arrow src={WhiteArrow} alt="arrow" />
          </S.RightWrapper>
        </S.ItemWrapper>
      </S.Link>
    );
  });

  return (
    <div className="main-inner">
      {title && <Title title={title} />}
      <S.Wrapper>{renderItems}</S.Wrapper>
      <S.Button>
        {displayOptions === "four" && <ArrowButton button={button} />}
      </S.Button>
    </div>
  );
};

export default PressReleases;
